import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: '"Inter", Arial, sans-serif',
    h1: {
      fontFamily: '"Inter SemiBold", Arial, sans-serif',
      fontSize: "3.5rem",
      fontWeight: 600,
      letterSpacing: "-0.02em",
      lineHeight: 1.2,
      background: "linear-gradient(45deg, #ffffff, #00ADB5)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    h2: {
      fontFamily: '"Inter SemiBold", Arial, sans-serif',
      fontSize: "2.5rem",
      fontWeight: 600,
      letterSpacing: "-0.01em",
      background: "linear-gradient(45deg, #ffffff, #00ADB5)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    h3: {
      fontFamily: '"Inter SemiBold", Arial, sans-serif',
      fontSize: "2rem",
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Inter SemiBold", Arial, sans-serif',
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Inter SemiBold", Arial, sans-serif',
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Inter SemiBold", Arial, sans-serif',
      fontSize: "1rem",
      fontWeight: 600,
    },
    subtitle1: {
      fontFamily: '"Inter", Arial, sans-serif',
      fontSize: "1.125rem",
      lineHeight: 1.5,
    },
    subtitle2: {
      fontFamily: '"Inter", Arial, sans-serif',
      fontSize: "0.875rem",
      fontWeight: 500,
    },
    body1: {
      fontFamily: '"Inter", Arial, sans-serif',
      fontSize: "1rem",
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: '"Inter", Arial, sans-serif',
      fontSize: "0.875rem",
      lineHeight: 1.6,
    },
    button: {
      fontFamily: '"Inter SemiBold", Arial, sans-serif',
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"Inter SemiBold", Arial, sans-serif',
          textTransform: "none",
          borderRadius: "10px",
          fontWeight: 600,
          fontSize: "1rem",
          padding: "0.625rem 1.5rem",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-2px)",
          },
        },
        text: {
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        },
        outlined: {
          borderColor: "#ffffff",
          color: "#ffffff",
          borderWidth: "1px",
          "&:hover": {
            borderColor: "#00ADB5",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        },
        contained: {
          backgroundColor: "#ffffff",
          color: "#000000",
          "&:hover": {
            backgroundColor: "#00ADB5",
            color: "#ffffff",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          borderRadius: "12px",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            borderColor: "white",
            transform: "translateY(-5px)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            transition: "all 0.3s ease-in-out",
            "&:hover": {
              borderColor: "white",
            },
            "&.Mui-focused": {
              borderColor: "white",
            },
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: "0",
          },
        },
      },
    },
  },
  palette: {
    mode: "dark",
    primary: {
      main: "#00ADB5",
      light: "#4FD1C5",
      dark: "#00838F",
    },
    background: {
      default: "#101010",
      paper: "#000000",
      black_shade_secondary: "#1e1e1e",
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255, 255, 255, 0.7)",
    },
  },
});

export default theme;
